import React from 'react';

/** Écran de chargement fiche programme — fond blanc + skeleton (pas de flash noir). */
export default function ProjectDetailLoadingShell() {
  return (
    <div
      className="project-detail-page relative min-h-screen bg-white text-neutral-900"
      aria-busy="true"
      aria-live="polite"
      aria-label="Chargement du programme"
    >
      <div className="container-custom animate-pulse space-y-6 py-5 pt-8 md:pt-10">
        <div className="space-y-3">
          <div className="flex gap-2">
            <div className="h-7 w-24 rounded-md bg-neutral-200" />
            <div className="h-7 w-28 rounded-md bg-neutral-100" />
          </div>
          <div className="h-10 max-w-xl rounded-lg bg-neutral-200" />
          <div className="h-5 w-56 rounded bg-neutral-100" />
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="space-y-3 lg:col-span-2">
            <div className="h-80 rounded-xl bg-neutral-100 sm:h-96 lg:h-[28rem]" />
            <div className="flex gap-3">
              <div className="h-20 w-24 shrink-0 rounded-lg bg-neutral-100" />
              <div className="h-20 w-24 shrink-0 rounded-lg bg-neutral-100" />
              <div className="h-20 w-24 shrink-0 rounded-lg bg-neutral-100" />
            </div>
          </div>
          <div className="h-72 rounded-xl border border-neutral-100 bg-neutral-50 lg:h-80" />
        </div>

        <div className="space-y-3 rounded-xl border border-neutral-100 bg-neutral-50 p-6">
          <div className="h-6 w-40 rounded bg-neutral-200" />
          <div className="h-4 w-full rounded bg-neutral-100" />
          <div className="h-4 w-full rounded bg-neutral-100" />
          <div className="h-4 w-4/5 rounded bg-neutral-100" />
        </div>
      </div>

      <div className="pointer-events-none absolute inset-0 flex items-center justify-center bg-white/40 backdrop-blur-[1px]">
        <div className="flex flex-col items-center gap-3 rounded-2xl border border-neutral-200/80 bg-white/95 px-8 py-6 shadow-lg">
          <div
            className="h-9 w-9 animate-spin rounded-full border-[3px] border-neutral-200 border-t-orange-500"
            role="status"
            aria-hidden
          />
          <p className="font-sans text-sm font-medium text-neutral-600">Chargement du programme…</p>
        </div>
      </div>
    </div>
  );
}
